/**
 * The enum used for increase or decrease indentation of a block
 * Used by setIndentation API
 */
// eslint-disable-next-line etc/no-const-enum
export enum CompatibleIndentation {

    /**
     * Increase indentation
     */
    Increase,

    /**
     * Decrease indentation
     */
    Decrease,
}
